module.exports = __webpack_public_path__ + "static/media/img_authenticate.33f1c955.svg";